import { categories, hotList, newsFeed } from "../../../mocks/news";

const accentMap: Record<string, string> = {
  娱乐: "bg-primary-500",
  社会: "bg-secondary-500",
  科技: "bg-accent-500",
  民生: "bg-accent-400",
  文体: "bg-primary-400",
};

const iconMap: Record<string, string> = {
  娱乐: "ri-star-smile-line",
  社会: "ri-earth-line",
  科技: "ri-cpu-line",
  民生: "ri-heart-pulse-line",
  文体: "ri-film-line",
};

export default function CategoryDigest() {
  return (
    <section id="category" className="mx-auto max-w-6xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-24">
            <p className="flex items-center gap-2 text-sm font-semibold text-primary-600">
              <span className="h-px w-6 bg-primary-400" aria-hidden="true" />
              分类导览
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              按兴趣分类快报
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              娱乐、社会、科技、民生、文体五大类当天焦点一目了然，点击分类色块即可直达对应速递，快速定位你想吃的那口瓜。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {categories.map((c, i) => (
                <a
                  key={c}
                  href="#latest"
                  className="inline-flex items-center gap-1.5 rounded-full bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 ring-1 ring-background-200 transition-colors hover:text-primary-700"
                >
                  <span className={`h-2.5 w-2.5 rounded-full ${accentMap[c]}`} aria-hidden="true" />
                  {c}
                  <span className="text-xs text-foreground-400">{i + 1}</span>
                </a>
              ))}
            </div>
            <div className="mt-8 rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 p-6 text-white">
              <i className="ri-zoom-in-line text-2xl" aria-hidden="true" />
              <p className="mt-3 font-heading text-lg font-bold">编辑部今日推荐</p>
              <p className="mt-1 text-sm text-white/85">
                瓜田虽热，理性围观。我们每日从大量信源中挑选最值得一看的焦点，帮你节省刷屏时间。
              </p>
            </div>
          </div>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:col-span-8">
          {categories.map((c) => {
            const catNews = newsFeed.filter((n) => n.category === c);
            const relatedHot = hotList.filter((h) => h.category === c).slice(0, 2);
            return (
              <article
                key={c}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-50"
              >
                <div className="flex items-center justify-between border-b border-background-200 bg-background-100/50 px-5 py-3.5">
                  <p className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
                    <span className={`flex h-7 w-7 items-center justify-center rounded-lg text-sm text-white ${accentMap[c]}`}>
                      <i className={iconMap[c]} aria-hidden="true" />
                    </span>
                    {c}速递
                  </p>
                  <a href="#latest" className="text-xs text-foreground-500 hover:text-primary-700">
                    看全部 <i className="ri-arrow-right-line align-middle" aria-hidden="true" />
                  </a>
                </div>
                <ul className="divide-y divide-background-100 px-5">
                  {relatedHot.map((h) => (
                    <li key={h.id}>
                      <a href="#hot" className="group flex items-start gap-3 py-3">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-background-100 text-xs font-bold text-foreground-600">
                          {h.rank}
                        </span>
                        <p className="text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                          {h.title.replace(/^#|#$|#/g, "")}
                        </p>
                      </a>
                    </li>
                  ))}
                  {catNews[0] && (
                    <li key={`news-${catNews[0].id}`}>
                      <a href="#latest" className="group flex items-start gap-3 py-3">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xs font-bold text-secondary-700">
                          <i className="ri-flashlight-fill" aria-hidden="true" />
                        </span>
                        <p className="text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-700">
                          {catNews[0].title}
                        </p>
                      </a>
                    </li>
                  )}
                </ul>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}